<div class="loader">
  <div class="loader-spinner"></div>
</div>
